<template>
  <VCard class="elevation-6 mt-4">
    <VCardTitle class="grey darken-2 white--text">
      <VLayout row wrap justify-center>
        <VFlex xs12 text-xs-center>
          <h3>Save This Page to Your Home Screen</h3>
        </VFlex>
      </VLayout>
    </VCardTitle>

    <VCardText class="pa-4 instructions-content">
      <div v-html="renderedMarkdown"></div>
    </VCardText>
  </VCard>
</template>

<script>
import { VLayout, VFlex } from 'vuetify/lib'
import { VCard, VCardTitle, VCardText } from '@vuetify/VCard'
import { marked } from 'marked'
import instructionsMd from './save-to-homescreen.md'

export default {
  name: 'SaveLinkInstructions',
  components: {
    VLayout,
    VFlex,
    VCard,
    VCardTitle,
    VCardText,
  },
  computed: {
    renderedMarkdown() {
      const raw = instructionsMd.default || instructionsMd
      return marked(raw)
    },
  },
}
</script>

<style scoped>
.instructions-content {
  font-size: 14px;
  line-height: 1.6;
  text-align: left;
}

.instructions-content >>> h2 {
  color: #e65100;
  font-size: 18px;
  font-weight: 500;
  margin-bottom: 8px;
}

.instructions-content >>> ol {
  padding-left: 20px;
}

.instructions-content >>> ol li {
  margin-bottom: 8px;
}

.instructions-content >>> a {
  color: #e65100;
  text-decoration: none;
}

.instructions-content >>> a:hover {
  text-decoration: underline;
}

.instructions-content >>> hr {
  border: none;
  border-top: 1px solid #e0e0e0;
  margin: 16px 0;
}
</style>
